// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--ea4d9";
export var markdown = "styles-module--markdown--8b14f";
export var toggle = "styles-module--toggle--47c99";